import { jwtDecode } from 'jwt-decode';
import moment from 'moment';

// this has to be eventually coming from the backend. But for now, getting org from frontend
export function getOrg(token) {
  if (token !== '') {
    let group = '';
    const decoded = jwtDecode(token);
    const userGroup = decoded['cognito:groups'] || [];
    if (userGroup.length > 0) {
      group = userGroup[0].split('_')[0];
    }
    return group;
  } else {
    return '';
  }
}

// Formats a date string to include an ordinal suffix (2nd, 5th, 1st etc..)
export const formatDate = (dateToFormat, options = { year: 'numeric', month: 'long', day: 'numeric' }) => {
  const date = new Date(dateToFormat);
  const formattedDate = date.toLocaleDateString('en-US', options);
  return formattedDate;
};

// Input: formatDateWithOrdinalSuffix(date)
// Output: Nov 22nd, 2024
export const formatDateWithOrdinalSuffix = (
  dateToFormat,
  options = { year: 'numeric', month: 'long', day: 'numeric' },
) => {
  const monthFormat = options.month === 'long' ? 'MMMM' : 'MMM';
  const dayFormat = options.day === 'numeric' ? 'Do' : '';
  const yearFormat = options.year === 'numeric' ? 'YYYY' : '';

  let formatParts = [monthFormat, dayFormat];
  if (dayFormat && yearFormat) {
    formatParts.push(`, ${yearFormat}`);
  } else if (yearFormat) {
    formatParts.push(yearFormat);
  }

  const formatString = formatParts.filter(Boolean).join(' ').replace(' ,', ',');

  return moment(dateToFormat).format(formatString);
};

// get the number from the GID
export function getNumberFromGID(gid) {
  return gid.match(/\d+/)[0];
}
